export const ADMIN_GET_PASSOS_IMPLANTACAO = "ADMIN_GET_PASSOS_IMPLANTACAO";
export const ADMIN_LOAD_PWC = "ADMIN_LOAD_PWC";
export const ADMIN_LOAD_PWCS = "ADMIN_LOAD_PWCS";
export const ADMIN_LOAD_CONFIG = "ADMIN_LOAD_CONFIG";
export const ADMIN_UPDATE_PUBLISH = "ADMIN_UPDATE_PUBLISH";
